import { useAppSelector, useAppTranslation } from 'app/hooks';
import Typo from 'consts/typography';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import HomeCasino from 'features/casino/components/HomeCasino';
import ServiceMenuBar from 'features/chatRoom/components/ServiceMenuBar';
import {
  onChangeAuthPage,
  selectIsShowBetForm,
  setShowBetForm,
  setShowSubMenu,
} from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import React, { useEffect, useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { platformStates } from 'redux/platformSlice';
import BetFormMainTab from './BetFormMainTab';
import BetSlipForm from './BetSlipForm';
import ChatRoom from './ChatRoom';
import MyBetsForm from './MyBetsForm';

interface BetFormProps {}

const BetForm: React.FunctionComponent<BetFormProps> = (props) => {
  const [currentTab, setCurrentTab] = React.useState<number>(1);
  const isShowBetForm = useAppSelector(selectIsShowBetForm);
  const dispatch = useDispatch();
  const { isLargeDesktop, isDesktop, isLaptop } = useAppSelector(platformStates);
  const t = useAppTranslation();
  const { isUserLoggedIn } = useUserDetail();
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.target === event.currentTarget) dispatch(setShowBetForm(false));
  };

  const closeBetForm = (): void => {
    dispatch(setShowBetForm(false));
  };

  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  useEffect(() => {
    setCurrentTab(1);
  }, [isUserLoggedIn]);

  const changeTab = (tab: number): void => {
    setCurrentTab(tab);
  };
  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  return (
    <>
      {(isLargeDesktop || isDesktop) && !isLaptop ? (
        <div className={`bet-and-chat `}>
          <div className="betchatContainer">
            <ChatRoom />
            <HomeCasino />
          </div>
        </div>
      ) : (
        <div
          className={`overlay-bet-form z-500 primary-text-color ${
            isShowBetForm ? 'overlay-bet-form__show' : 'overlay-bet-form__hide'
          }`}
          onClick={handleOverlayClick}
        >
          <div className="bet-form">
            <div className="bet-form-header">
              <h3 className={`primary-text-color ${Typo.h3}`}>{t('betFormMainTab.betSlip')}</h3>
              <button onClick={closeBetForm}>
                <AiOutlineCloseCircle className="w-6 h-6 font-bold primary-text-color" />
              </button>
            </div>
            <BetFormMainTab currentTab={currentTab} changeTab={changeTab} />
            {currentTab === 1 && <BetSlipForm />}
            {currentTab === 2 && <MyBetsForm />}
          </div>
        </div>
      )}
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
    </>
  );
};

export default BetForm;
